<template>
  <div class="global-container container-fluid">
    <div class="row">
      <div class="col-lg-7 right-reg">
        <div class="card login-form">
          <div class="card-body">
            <div id="logo_home" class="logologin">
              <h1>
                <img
                  src="../../../public/img/logo-pardis.png"
                  alt="City tours"
                  data-retina="true"
                  @click.prevent="gotoHome"
                  style="cursor: pointer"
                />
              </h1>
            </div>
            <div class="login-top-title">
              <h3>{{ $t("Signup") }}</h3>
            </div>

            <form v-on:submit.prevent="onSubmit">
              <div class="sign-in-wrapper">
                <div class="row">
                  <div class="group_mdi col-sm-6">
                    <i class="icon-user-8"></i>
                    <input
                      type="text"
                      required
                      v-model="user.firstName"
                      @blur="$v.user.firstName.$touch()"
                      :class="{ invalid: $v.user.firstName.$error }"
                    />
                    <span class="highlight"></span>
                    <span class="bar"></span>
                    <label>{{ $t("Name") }}</label>
                    <p
                      class="text-danger"
                      v-if="
                        !$v.user.firstName.required && $v.user.firstName.$dirty
                      "
                    >
                      {{ $t("PleaseEnterName") }}
                    </p>
                  </div>
                  <!-- <div class="form-group inputContainer col-md-6">
                <label>نام</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="user.firstName"
                  @blur="$v.user.firstName.$touch()"
                  :class="{ invalid: $v.user.firstName.$error }"
                />
                <i class="icon-user"></i>
                <p
                  class="text-danger"
                  v-if="!$v.user.firstName.required && $v.user.firstName.$dirty"
                >
                  لطفا نام را وارد کنید
                </p>
              </div> -->
                  <div class="group_mdi col-sm-6">
                    <i class="icon-user-8"></i>
                    <input
                      type="text"
                      required
                      v-model="user.lastName"
                      @blur="$v.user.lastName.$touch()"
                      :class="{ invalid: $v.user.lastName.$error }"
                    />
                    <span class="highlight"></span>
                    <span class="bar"></span>
                    <label> {{ $t("LName") }}</label>
                    <p
                      class="text-danger"
                      v-if="
                        !$v.user.firstName.required && $v.user.firstName.$dirty
                      "
                    >
                       {{ $t("PleaseEnterLastName") }}
                    </p>
                  </div>
                  <!-- <div class="form-group inputContainer col-md-6">
                <label>نام خانوادگی</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="user.lastName"
                  @blur="$v.user.lastName.$touch()"
                  :class="{ invalid: $v.user.lastName.$error }"
                />
                <i class="icon-user"></i>
                <p
                  class="text-danger"
                  v-if="!$v.user.lastName.required && $v.user.lastName.$dirty"
                >
                  لطفا نام خانوادگی را وارد کنید
                </p>
              </div> -->
                </div>

                <div class="row">
                  <div class="group_mdi col-md-6">
                    <i class="icon_mail_alt"></i>
                    <input
                      type="email"
                      required
                      v-model="user.email"
                      @blur="$v.user.email.$touch()"
                      :class="{ invalid: $v.user.email.$error }"
                    />
                    <span class="highlight"></span>
                    <span class="bar"></span>
                    <label>  {{ $t("EmailSignup") }}</label>
                    <p
                      class="text-danger"
                      v-if="!$v.user.email.required && $v.user.email.$dirty"
                    >
                     {{ $t("PleaseEnterEmail") }}
                      
                    </p>
                    <p class="text-danger" v-if="!$v.user.email.email">
                      {{ $t("EmailNotValid") }}
                      
                    </p>
                    <p class="text-danger" v-if="$v.user.email.$error">
                      {{ $t("EmailIsDuplicate") }}
                    </p>
                  </div>
                  <div class="group_mdi col-md-6">
                    <i class="icon-phone"></i>
                    <input
                      type="number"
                      required
                      maxlength="11"
                      v-model="user.cellPhoneNumber"
                      @blur="$v.user.cellPhoneNumber.$touch()"
                      :class="{ invalid: $v.user.cellPhoneNumber.$error }"
                    />
                    <span class="highlight"></span>
                    <span class="bar"></span>
                    <label>{{ $t("MobileNumber") }} </label>
                    <p
                      class="text-danger"
                      v-if="
                        !$v.user.cellPhoneNumber.required &&
                        $v.user.cellPhoneNumber.$dirty
                      "
                    >
                      {{ $t("PleaseEnterMobileNumber") }}
                    </p>
                    <p
                      class="text-danger"
                      v-if="
                        !$v.user.cellPhoneNumber.minLength &&
                        $v.user.cellPhoneNumber.$dirty
                      "
                    >
                      {{ $t("PleaseEnterCorrectMobileNumber") }}
                    </p>
                  </div>
                </div>

                <div class="row">
                  <div class="group_mdi col-sm-6">
                    <i class="icon_lock_alt"></i>
                    <input
                      required
                      type="password"
                      v-model="user.password"
                      @blur="$v.user.password.$touch()"
                      :class="{ invalid: $v.user.password.$error }"
                    />
                    <span class="highlight"></span>
                    <span class="bar"></span>
                    <label> {{ $t("Password") }}</label>
                    <p
                      class="text-danger"
                      v-if="user.password.length < 6 && $v.user.password.$dirty"
                    >
                      {{ $t("Atleast6CharractersForPassword") }}
                    </p>
                  </div>

                  <!-- <div class="form-group inputContainer col-md-6">
                <label>رمزعبور</label>
                <input
                  type="password"
                  class="form-control"
                  v-model="user.password"
                  @blur="$v.user.password.$touch()"
                  :class="{ invalid: $v.user.password.$error }"
                />
                <i class="icon_lock_alt"></i>
                <p
                  class="text-danger"
                  v-if="user.password.length < 6 && $v.user.password.$dirty"
                >
                  کلمه عبور حداقل شامل 6 کاراکتر باشد
                </p>
                <p
                  class="text-danger"
                  v-if="
                    (user.password.length < 8 ||
                      passwordValidation.errors.length) &&
                    $v.user.password.$dirty
                  "
                >
                  کلمه عبور باید حداقل شامل 8 حرف باشد، شامل حروف کوچک، بزرگ و
                  حداقل یک کاراکتر خاص باشد
                </p> -->

                  <div class="group_mdi col-sm-6">
                    <i class="icon_lock_alt"></i>
                    <input
                      required
                      type="password"
                      v-model="user.confirmPassword"
                      @blur="$v.user.confirmPassword.$touch()"
                      :class="{ invalid: $v.user.confirmPassword.$error }"
                    />
                    <span class="highlight"></span>
                    <span class="bar"></span>
                    <label>{{ $t("RepeatPassword") }}</label>
                    <p
                      class="text-danger"
                      v-if="
                        !$v.user.confirmPassword.required &&
                        $v.user.confirmPassword.$dirty
                      "
                    >
                    {{ $t("PleaseRepeatPassword") }}
                      
                    </p>
                    <p
                      class="text-danger"
                      v-if="!$v.user.confirmPassword.sameAsPassword"
                    >
                    {{ $t("RepeatingPasswordNotCorrect") }}                      
                    </p>
                  </div>
                </div>
                <div class="login-btn-sec">
                  <div class="dashed-line"></div>
                  <button
                    v-if="!isLoading"
                    type="submit"
                    class="btn_login"
                    @click="register"
                    :disabled="!isActive"
                  >
                    <!-- :disabled="$v.$invalid" :class="{ disabledBtn: $v.$invalid }"> -->
                    {{ $t("Signup") }} 
                  </button>

                  <button v-if="isLoading" type="submit" class="btn_login">
                    {{ $t("Signup") }} 
                    <loadingBar type="ring" class="loading-btn"></loadingBar>
                  </button>
                </div>
              </div>

              <div class="gotosignup">
                {{ $t("DoYouSignup") }} 
                
                <router-link to="/login" class="submenu-text"
                  >
                   {{ $t("HomeHeader.UserEntry") }} 
                  
                </router-link>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <button type="submit" class="home-btn" @click.prevent="gotoHome">
      <i class="icon-home-1"></i>
      {{ $t("MainPage") }} 
    </button>
  </div>
</template>


<script>
import {
  required,
  email,
  maxLength,
  minLength,
  sameAs,
} from "vuelidate/lib/validators";
import store from "@/views/profile/store/index";
import loadingBar from "@/components/loading/pdkLoadingBar";
import RegisterSuccess from "@/components/RegisterSuccess";
export default {
  name: "pdkRegister",
  components: {
    loadingBar,
    RegisterSuccess,
  },
  store: store,
  data() {
    return {
     isActive : true,
      id: "",
      user: {
        userName: "",
        firstName: "",
        lastName: "",
        // disabledBtn: false,
        email: "",
        cellPhoneNumber: "",
        password: "",
        confirmPassword: "",
        individualType: 1, //customer
        userId: "",
      },
       
      profile: {
        id: "",
        creatorProfileID: "",
        name: "",
        profileType: 1,
        status: 1,
      },
      data: {
        username: "",
        password: "",
        grant_type: "",
        client_id: "",
        client_secret: "",
        returnSecureToken: true,
      },
      rules: [
        { message: "شامل حداقل یک حروف کوچک باشد.", regex: /[a-z]+/ },
        { message: "شامل حداقل یک حروف بزرگ باشد.", regex: /[A-Z]+/ },
        { message: "شامل حداقل یک کاراکتر خاص باشد.", regex: /[!@#$%^&*()_+]/ },
      ],

      isLoading: false,
    };
  },
  validations: {
    user: {
      firstName: { required },
      lastName: { required },
      email: {
        required,
        email,
        maxLength: maxLength(100),

        async isUnique(email) {
          if (email.length > 5) {
            const valid = await this.$store.dispatch(
              "CheckEmailExist",
              this.user.email
            );
            if (valid.data === "The Email Address Was Not Found!") {
              return true;
            } else return false;
          }
        },
      },
      cellPhoneNumber: {
        required,
        maxLength: maxLength(11),
        minLength: minLength(11),
      },
      password: { required, minLength: minLength(6) },
      confirmPassword: { required, sameAsPassword: sameAs("password") },
    },
  },
  computed: {
    passwordValidation() {
      let errors = [];
      for (let condition of this.rules) {
        if (!condition.regex.test(this.user.password)) {
          errors.push(condition.message);
        }
      }
      if (errors.length === 0) {
        return { valid: true, errors };
      } else {
        return { valid: false, errors };
      }
    },
  },
  created() {
  },
  methods: {
    async register() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      this.isLoading = true;
      const relationModel = {
        parentProfileId: "",
        relatedProfileId: "",
        relationTypeId: 1,
      };

      this.user.gender = 1; // جنسیت پیش فرض مرد
      const register = await this.$store.dispatch("register", {
        profileModel: {
          id: null,
          creatorProfileID: "00000000-0000-0000-0000-000000000000",
          name: "",
          profileType: 1, // کاربر عادی
          status: 3, // در حال بررسی
          createdDate: "",
          individualModel: [],
          isUpdatedPassword: true, // سرویس سی ار اس در زمان لاگین فراخوانی نشود
          ProfileRelationCreateModel: [relationModel],
        },
        password: this.user.password,
        confirmPassword: this.user.confirmPassword,
        firstName: this.user.firstName,
        lastName: this.user.lastName,
        email: this.user.email,
        phoneNumber: this.user.cellPhoneNumber,
      });
      var wq= register;

      if (register.status == 200) {
        
        this.isLoading = false;
        if (register.data.responseData.errorCode == "0") {
          // this.$toast.success(
          //   " برای فعال سازی حساب کاربری ایمیل تائید را چک نمائید. در صورت عدم وجود در Inbox  لطفا قسمت Spam را نیز چک فرمایید",
          //   {
          //     position: "top-center",
          //     timeout: 4500,
          //     closeOnClick: true,
          //     pauseOnFocusLoss: true,
          //     pauseOnHover: true,
          //     draggable: true,
          //     draggablePercent: 1.59,
          //     showCloseButtonOnHover: false,
          //     hideProgressBar: false,
          //     icon: true,
          //     rtl: true,
          //   }
          // );
     setTimeout( () => this.$router.push({ path: '/login'}), 20000);
    this.isActive = false;
    this.$toast.success(RegisterSuccess, {
      position: "top-center",
      timeout: 20000,
      closeOnClick: false,
      pauseOnFocusLoss: false,
      pauseOnHover: false,
      draggable: true,
      draggablePercent: 1.39,
      showCloseButtonOnHover: false,
      closeButton: "button",
      rtl: true,
    });
        } else {
          alert(register.data.responseData.errorDescription);
        }
      } else {
        this.$toast.error(" خطا در ثبت اطلاعات ", {
          position: "top-center",
          timeout: 4500,
          closeOnClick: true,
          pauseOnFocusLoss: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 1.59,
          showCloseButtonOnHover: false,
          hideProgressBar: false,
          icon: true,
          rtl: true,
        });
        this.isLoading = false;
      }
    },

    gotoHome() {
      if (this.$route.name != "main home") this.$router.push("/");
    },
  },
};
</script>


<style scoped>
html,
body {
  height: 100%;
  background-color: #f5f7f9;
}

.global-container {
  height: 100vh;
  background-color: #f5f7f9;
  padding-top: 5%;
  background-image: url("../../../public/img/a89dausd90as90duajsdasd09 copy_c.jpg");
  background-size: cover;
}

.login-top-title {
  text-align: center;
  margin: 20px;
}
  
.login-top-title h3 {
  font-size: 16px;
  color: #2561a4;
}

.card-title {
  font-weight: 300;
}

.btn {
  font-size: 14px;
  margin-top: 20px;
}

.login-form {
  width: 88%;
  margin-right: 6%;
  border-radius: 25px;
  box-shadow: -1.2px -0.7px 2.2px rgb(0 0 0 / 1%),
    -1.4px -0.8px 5.3px rgb(0 0 0 / 2%), 0.1px 0px 10px rgb(0 0 0 / 2%),
    4.3px 2.5px 17.9px rgb(0 0 0 / 2%), 15.2px 8.8px 33.4px rgb(0 0 0 / 3%),
    50px 29px 80px rgb(0 0 0 / 4%);
}

.logologin {
  text-align: center;
}

.logologin img {
  width: 360px;

  margin-right: 0px;
}

.card-body {
  padding: 30px 15px 30px 15px;
  line-height: 1.6 !important;
  border-top: 0px solid;
}

.inputContainer i {
  position: absolute;
  margin: -34px 10px;
  text-align: left !important;
  float: left;
  font-size: 20px;
  color: #ccc;
}

/* .disabledBtn {
  background-color: #0e6d7c !important;
} */

.text-danger {
  margin: 0;
  display: inline-block;
  margin-left: 10px;
}

.inputContainer {
  width: 100%;
  margin-bottom: 10px;
}

.group_mdi .bar {
  position: relative;
  display: block;
}
.group_mdi {
  padding: 16px;
}
.group_mdi i {
  bottom: unset !important;
  top: 33px;
}

.group_mdi label {
  right: 80px;
  top: 35px;
}

.group_mdi input:focus ~ label,
.group_mdi input:valid ~ label,
input:-webkit-autofill ~ label {
  right: 40px !important;
  top: 0;
}

.login-btn-sec {
  margin-top: 40px;
}

.home-btn {
  border: 1px solid #fff;
  position: fixed;
  left: 70px;
  top: 70px;
  width: 120px;
  height: 120px;
  border-radius: 100%;
  box-shadow: -1.2px -0.7px 2.2px rgb(0 0 0 / 1%),
    -1.4px -0.8px 5.3px rgb(0 0 0 / 2%), 0.1px 0px 10px rgb(0 0 0 / 2%),
    4.3px 2.5px 17.9px rgb(0 0 0 / 2%), 15.2px 8.8px 33.4px rgb(0 0 0 / 3%),
    50px 29px 80px rgb(0 0 0 / 4%);
  background: #0e6d7c;
  color: #fff;
  font-size: 16px;
  line-height: 1.5;
}

.home-btn i {
  display: block;
  font-size: 30px;
  margin-top: -5px;
}

.margin-btn {
  margin-top: 25px;
}

#logo_home h1 a,
header#colored #logo_home h1 a,
header#plain #logo_home h1 a,
header.sticky #logo_home h1 a {
  width: 160px;
  height: 34px;
  display: block;
  background-image: url(../../../public/img/pdk_logo.png);
  background-repeat: no-repeat;
  background-position: left top;
  background-size: 160px 34px;
  text-indent: -9999px;
  text-align: center;
  margin: 20px;
}

@media (max-width: 767.98px) {
  .global-container {
    height: auto;
    background-image: url("../../../public/img/e4g9w88g4ew48g8we_dariushgroup.jpg");
    background-size: cover;
  }

  .card {
    background-color: #ffffffe8;
  }

  .login-form {
    width: 96%;
    margin-right: 2%;
  }

  .logologin img {
    width: 100%;
  }

  .login-top-title {
    display: none;
  }

  .forgot-password {
    margin-top: 20px;
  }

  .home-btn {
    display: none !important;
  }
}
</style>